import { render, staticRenderFns } from "./yzsyMainFrame.vue?vue&type=template&id=2302f8d6&scoped=true"
import script from "./yzsyMainFrame.vue?vue&type=script&lang=js"
export * from "./yzsyMainFrame.vue?vue&type=script&lang=js"
import style0 from "./yzsyMainFrame.vue?vue&type=style&index=0&id=2302f8d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2302f8d6",
  null
  
)

export default component.exports